import BaseEntity from '../../base/BaseEntity.model';
import Documento from '@/models/documento.model';

export default class TramiteLiberacionDocumento extends BaseEntity {
    public tramiteLiberacionId?: number;
    public numeroTramite?: string;
    public personaId?: number;
    public documentoId?: number;
    public documento?: Documento;
    public tipoDocumentoId?: number;
    public tipoDocumentoNombre?: string;
    constructor() {
        super();
        this.tramiteLiberacionId = undefined;
        this.numeroTramite = undefined;
        this.personaId = undefined;
        this.documentoId = undefined;
        this.documento = undefined;
        this.tipoDocumentoId = undefined;
        this.tipoDocumentoNombre = undefined;
    }
}